export type AudioExportFormat = "m4a" | "wav";
export type AudioExportChannels = 1 | 2;
export type AudioExportSampleRate = 44100 | 48000;

export type AudioExportSettings = {
    format: AudioExportFormat;
    bitrate: number;
    channels: AudioExportChannels;
    sampleRate: AudioExportSampleRate;
};

export const AUDIO_EXPORT_FORMAT_OPTIONS: Array<{
    value: AudioExportFormat;
    label: string;
}> = [
    { value: "wav", label: "Lossless WAV audio (.wav)" },
    { value: "m4a", label: "AAC audio (.m4a)" },
];

export const AUDIO_EXPORT_BITRATE_OPTIONS: number[] = [
    32000,
    48000,
    64000,
    96000,
    128000,
    160000,
    192000,
    256000,
];

export const DEFAULT_AUDIO_EXPORT_SETTINGS: AudioExportSettings = {
    format: "m4a",
    bitrate: 128000,
    channels: 2,
    sampleRate: 44100,
};

export const normalizeAudioExportFormat = (value: unknown): AudioExportFormat =>
    String(value ?? "").trim().toLowerCase() === "wav" ? "wav" : "m4a";

export const normalizeAudioExportSampleRate = (value: unknown): AudioExportSampleRate =>
    Number(value) === 44100 ? 44100 : 48000;
